import React from 'react';
import { _T } from '../../../include/appI18n';
import { ServicePerson } from './ServicePerson';
export function ServiceTouristsBlock({ cart, service, onTouristChange }) {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, _T.BOOKING_ARRIVED_NAMES),
        React.createElement("div", { className: "arrived-info", "data-service-id": service.id }, (_a = service.tourists) === null || _a === void 0 ? void 0 : _a.map((tourist, index) => (React.createElement(ServicePerson, Object.assign({}, cart, { key: index, bookingService: service, age: index < service.accommodation.adults ? -1 : service.accommodation.childAccommodations[index - service.accommodation.adults].age, isAdult: index < service.accommodation.adults, personIdx: index, tourist: tourist, onChange: onTouristChange })))))));
}
